module.exports = __webpack_public_path__ + "img/settings.e8dfab8e.svg";